import React from 'react';
import {FormattedMessage} from "react-intl";
import {useFormikContext} from "formik";

import SelectTitle from "components/radioGroup/SelectTitle";
import RadioGroup from "components/radioGroup/RadioGroup";
import FormControlLabel from "components/radioGroup/FormControlLabel";

import {DeliveryModes} from "utils/ShippingMethods";

function DeliveryModeField(props) {
    const {values, setFieldValue, setFieldTouched} = useFormikContext();

    return (
        <>
            <SelectTitle
                titleTranslationKey={'shippingMethods.form.field.deliveryMode.label'}
                required={true}
            />
            <RadioGroup
                alignListWithButton
                placeholder={<FormattedMessage id={'shippingMethods.form.field.deliveryMode.placeholder'}/>}
                selectedValueLabel={values.deliveryMode ? <FormattedMessage id={`shippingMethods.deliveryMode.${values.deliveryMode}`}/> : ''}
                name={'deliveryMode'}
                value={values.deliveryMode}
                onClickAway={() => setFieldTouched('deliveryMode')}
                onChange={(event, value) => {
                    setFieldValue('deliveryMode', value);
                }}
            >
                {DeliveryModes.toArray().map(deliveryMode => (
                    <FormControlLabel
                        key={deliveryMode}
                        value={deliveryMode}
                        label={<FormattedMessage id={`shippingMethods.deliveryMode.${deliveryMode}`}/>}
                    />
                ))}
            </RadioGroup>
        </>
    );
}

export default DeliveryModeField;
